// Перемикачі можливостей: що зараз продається (backend/api/src/features.js).
// Правда — на сервері, і приходить вона в GET /me (поле features), тож
// перемикання не потребує релізу клієнта. Поки /me старий, без поля,
// усе вважається вимкненим: краще на хвилину сховати кнопку, ніж показати
// покупку, яку сервер відхилить.
export const feature = (me, name) => Boolean(me?.features?.[name]);
